import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: 'cursor-pointer p-0 appearance-none bg-transparent no-underline',
  },
}));
